// base react-slick 0.23.2
import Slider from './slider';

export default Slider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-slick/src/index.js
// module id = null
// module chunks = 